module.exports = __webpack_public_path__ + "img/文化日語.35973417.png";